
@if (dataListForDhsGRid) {
  <div class="table-responsive max-height-unset" style="max-height: 80vh;overflow: auto;">
    <div>
      <table class="table mb-0">
        <thead>
          <tr style="position: sticky; top: 0; z-index: 2;">
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Service Item</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Value</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          @for (keyValuePair of dataListForDhsGRid | keyvalue; track keyValuePair) {
            <tr>
              <ng-container>
                @if (keyValuePair.key) {
                  <td style="min-width: 8.5em;">
                    {{ keyValuePair.key }}
                  </td>
                }
                <td scope="row">
                  {{ dataListForDhsGRid[keyValuePair.key] == 'true' ? '': dataListForDhsGRid[keyValuePair.key] }}
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
@if (segmentData) {
  <div class="table-responsive max-height-unset" >
    <div class="kx-cstm-popup-title"><h5>{{dialogConfig.name}}</h5><span class="kx-modal-close"><i aria-hidden="true" class="fa fa-times-circle" (click)="close()" ></i></span></div>
    <div style="max-height: 80vh;overflow: auto;">
      <table class="table">
        <thead>
          <tr style="position: sticky; top: 0; z-index: 2;">
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Anterior Segment</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              RE</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              LE</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Created By</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Creation Date/Time</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
              Modified Date/Time</th>
            </ng-container>
            <ng-container>
              <th scope="col" style="min-width: 5.2em;">
                <button style="background-color: #00f;color: #fff;border-radius: 5px;" (click)="copyHistory()">Copy All <i class="fa fa-copy ml-2" aria-hidden="true"></i></button>
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          @for (keyValuePair of examinationData | keyvalue; track keyValuePair) {
            <tr>
              <ng-container>
                @if (keyValuePair.key) {
                  <td style="min-width: 8.5em;">
                    {{ convertString(keyValuePair.key) }}
                  </td>
                }
              </ng-container>
              <td style="min-width: 8.5em;">
                {{ getFormattedRE(keyValuePair.value) }}
              </td>
              <td style="min-width: 8.5em;">
                {{ getFormattedLE(keyValuePair.value) }}
              </td>
              <ng-container>
                @if (segmentData.g_created_by_name) {
                  <td style="min-width: 8.5em;">
                    {{ segmentData.g_created_by_name }}
                  </td>
                }
              </ng-container>
              <ng-container>
                @if (segmentData.g_creation_time) {
                  <td style="min-width: 8.5em;">
                    {{ (segmentData.g_creation_time | dateTimeFormat)}}
                  </td>
                }
              </ng-container>
              <ng-container>
                @if (segmentData.g_modify_time) {
                  <td style="min-width: 8.5em;">
                    {{ (segmentData.g_modify_time | dateTimeFormat)}}
                  </td>
                }
              </ng-container>
              <ng-container>
                <td style="min-width: 8.5em;">
                  <button style="background-color: #00f;color: #fff;border-radius: 5px;" (click)="copy(keyValuePair.key)"><i class="fa fa-copy" aria-hidden="true"></i>
                </button>
              </td>
            </ng-container>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
}